import Home from '@/views/home'
import error from '@/views/comPages/error'
import rulePage from '@/views/comPages/rule'
import endPage from '@/views/comPages/end'
import userAccount from '@/views/userAccount/userAccount'
import userAccountNew from '@/views/userAccount/userAccountNew'
import questionnaire from '@/views/questionnaire/questionnaire'
import questionnaireList from '@/views/questionnaire/questionnaireList'
import mutualHelpList from '@/views/mutualHelp/mutualHelpList'

const routes = [
  {
    path: '/',
    redirect: '/questionnaireList',
    name: 'home',
    component: Home,
    children: [
      {
        path: '/userAccount',
        name: 'userAccount',
        meta: {
          noAuth: false,
        },
        component: userAccount,
      },
      {
        path: '/userAccountNew',
        name: 'userAccountNew',
        meta: {
          noAuth: false,
        },
        component: userAccountNew,
      },
      {
        path: '/questionnaire',
        name: 'questionnaire',
        meta: {
          noAuth: false,
        },
        component: questionnaire,
      },
      {
        path: '/questionnaireList',
        name: 'questionnaireList',
        meta: {
          noAuth: false,
        },
        component: questionnaireList,
      },
      {
        path: '/mutualHelpList',
        name: 'mutualHelpList',
        meta: {
          noAuth: false,
        },
        component: mutualHelpList,
      },
    ],
  },
  {
    path: '/error',
    name: 'error',
    meta: {
      noAuth: true, // 不需要授权
    },
    component: error,
  },
  {
    path: '/rulePage',
    name: 'rulePage',
    meta: {
      noAuth: false,
    },
    component: rulePage,
  },
  {
    path: '/endPage',
    name: 'endPage',
    meta: {
      noAuth: false, // 不需要授权
    },
    component: endPage,
  },
]

export default routes
